<!-- 本组件是 读取以及显示 富文本内容弹窗 -->
<template>
  <el-dialog :title="title" :close-on-click-modal="false" @close="close" :visible.sync="visiblesource" width="1000px" top="1vh">
    <div id="textImg" style="text-align: left" v-html="textBody"></div>
  </el-dialog>
</template>
<script>
var _poi;
import { marked } from "marked"
export default {
  name: 'htmlup',
  props: {
    data: {
      type: Object,
      default() {
        return {};
      }
    }
  },
  data() {
    return {
      title: '',
      textBody: "",
      visiblesource: false, // 弹窗开关
    };
  },
  created() {
    _poi = this;
    this.initFormPick(); // 默认进入初始化
  },
  methods: {
    // 初始化
    initFormPick() {
      let content = '';
      this.title = this.data.teltetext;
      if (this.data.ruleBody.indexOf('&lt;') == -1) { // 旧内容 回显方式
        content = marked(this.data.ruleBody);
      } else { // 新内容 回显方式
        content = this.HTMLDecode(this.data.ruleBody);
      }

      this.steImghttp(content);
      this.visiblesource = true;
    },
    // 这个是当弹窗关闭时 注销弹窗
    close() {
      this.$emit('close', this.$options._componentTag);
    },


    // 将所有图片地址前缀更换以及设置宽高后再渲染到页面
    steImghttp(content) {
      let newContent = content.replace(/<img [^>]*src=['"]([^'"]+)[^>]*>/gi, function (match, capture) {
        let setWidth = ''
        let widthc = match.replace(/[ t]*width[ t]*=[ t]*("[^"]+")|('[^'])/ig, function (widtha, bbb) {
          setWidth = widtha
          return bbb;
        });
        let regK = new RegExp("(?<=[http|https]://[a-zA-Z0-9-.]+:{0,1}[0-9]*/).*", 'ig'); // 正则去除图片路径的前缀
        //capture,返回每个匹配的字符串
        let ling = regK.exec(capture);
        let windroot = process.env.API_ROOT;
        var newStr = '<img src="' + windroot + ling[0] + '"' + setWidth + ' alt="" />';
        return newStr;
      });
      this.textBody = newContent;
    },

    //HTML反转义
    HTMLDecode(text) {
      var temp = document.createElement("div");
      temp.innerHTML = text;
      var output = temp.innerText || temp.textContent;
      temp = null;
      return output;
    }



  }
};
</script>

<style scoped></style>





// WEBPACK FOOTER //
// src/components/htmlUp/index.vue